<template>
    <div>
        <h1>Nitroalkane</h1>
        <p>
            Nitroalkane sind nicht-aromatische Kohlenwasserstoffe, bei denen
            mindestens ein Wasserstoff-Atom durch eine Nitro-Gruppe ersetzt ist.
            Die Nitro-Gruppe besitzt eine mesomere Grenzstruktur und wird
            deshalb stets durch <code>NO<sub>2</sub></code> statt Strukturformel
            dargestellt.
        </p>
        <chapter-heading title="Allgemeine Struktur"></chapter-heading>
        <img
            src="@/assets/img/stoffe/nitroalkane/allgemeine-struktur.png"
            alt="Allgemeine Struktur der Nitroalkane"
            title="Allgemeine Struktur der Nitroalkane"
        />
        <br />
        Von oben nach unten: primäre Nitroalkane, sekundäre Nitroalkane und
        tertiäre Nitroalkane.
    </div>
</template>
<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
